<template>
  <div class="product__stock-container" :class="isMobile ? 'show-for-small-only' : 'hide-for-small-only'">
    <span class="product__stock _red" v-if="outOfStockMessage" v-html="outOfStockMessage"></span>
    <span class="product__stock _green" v-else-if="isPpcProduct && hasPpcDeliveryPromise">Op voorraad: {{ ppcdeliveryPromise }}</span>
    <span class="product__stock _green" v-else-if="isPpcProduct"><slot name="ppc_shipment_time"></slot></span>
    <span class="product__stock _green" v-else-if="swStock > 0">Voor 17.00 besteld, vandaag verstuurd</span>
    <span v-else-if="hasDeliveryPromise">
      <span class="product__stock">Niet op voorraad: {{ deliveryPromise }} levertijd</span>
    </span>
    <span v-else>
      <span class="product__stock">Niet op voorraad = 2-4 werkdagen levertijd</span>
    </span>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component(
  {
    name: 'catalog-product-stock'
  }
)

export default class extends Vue {
  @Prop({default: false}) isMobile: boolean;

  private get swStock(): number {
    return this.$store.getters['CatalogCategoryProduct/swStock'];
  }

  private get hasDeliveryPromise(): number {
    return this.$store.state.CatalogProduct['productData'].hasOwnProperty('swff_delivery_promise')
  }

  private get deliveryPromise(): number {
    return this.$store.state.CatalogProduct['productData']['swff_delivery_promise'];
  }

  private get isPpcProduct(): boolean {
    return this.$store.state.CatalogProduct['productData'].hasOwnProperty('is_ppc') &&
      this.$store.state.CatalogProduct['productData'].is_ppc;
  }

  private get ppcdeliveryPromise(): number {
    return this.$store.state.CatalogProduct['productData']['swff_ppc_delivery_notice'];
  }

  private get hasPpcDeliveryPromise(): number {
    return this.$store.state.CatalogProduct['productData'].hasOwnProperty('swff_ppc_delivery_notice')
  }

  private get outOfStockMessage(): boolean {
    return this.$store.state.CatalogProduct['productData'].hasOwnProperty('out_of_stock_message') &&
      this.$store.state.CatalogProduct['productData'].out_of_stock_message;
  }


}
</script>
